import { Component, Input } from '@angular/core';

@Component({
    selector: 'ess-col',
    templateUrl: './col.html',
    styleUrls: ['./col.scss']
})
export class SmartCol {

    @Input('flex')
    flex: number = 1;
}